import React, {Component} from 'react';
import './index.scss';
import CrgtEvent from '../CrgtEvent';
export default class VersionButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showText: true
    };
  }

  handleClick = () => {
    this.setState({ showText: !this.state.showText });
  }
  render(){
    const exclaimImg = 'https://static.ccrgt.com/movie/assets/images/exclaim.png';
    const { text = '版本过低请升级', imgUrl = exclaimImg, background = '#fea11d', color = '#fff' } = this.props;
    const compareVersion = CrgtEvent.compare('1.1.5');
   // const compareVersion = -1;
 
    return (<>{
      compareVersion < 0 ? <button className="version-button" style={{background, color}} onClick={this.handleClick}>
        <img src={imgUrl} alt="" />
        <span>{this.state.showText ? text: ''}</span>
      </button> : <></>
    }</>)
  }
}